import * as api from "Api";
import * as actions from "Actions";
import { ACCESS_KEY_DURATION } from "Config";

export const fetchPresentationAccessKey = (target, period) => {
  return (dispatch, getState) => {
    return dispatch(
      actions.fetchPresentationAccessKey(
        api.getAccessKey(target, period).then(res => {
          return res.data.data;
        })
      )
    );
  };
};

export const generatePresentationAccessKey = (target, period) => (
  dispatch,
  getState
) => {
  const {
    accessKey: { duration }
  } = getState();

  let expires = ACCESS_KEY_DURATION[duration.value];

  return dispatch(
    actions.generatePresentationAccessKey(
      api.generatePresentationAccessKey({
        target,
        expires: expires,
        period
      })
    )
  );
};

export const verifyPresentationAccessKey = (target, accessKey) => {
  return (dispatch, getState) => {
    return dispatch(
      actions.verifyPresentationAccessKey(
        api.verifyAccessKey(target, accessKey).then(res => {
          return res.data.data;
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/access-key.js